import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@uncinc/uncinc-react-kitchen-sink';

import { ErrorPage, SearchAllContent } from '../../components';
import { SEARCHKIT_HITS_PER_PAGE_ALL_CONTENT_AUTOSUGGEST } from '../../config/constants';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <ErrorPage>
      <h1>{t('pages.404.title')}</h1>

      <SearchAllContent
        className="mb-12"
        routing
        hitsPerPage={SEARCHKIT_HITS_PER_PAGE_ALL_CONTENT_AUTOSUGGEST}
        onlyFetchWithQuery
      >
        <SearchAllContent.SearchBarAutosuggest />
      </SearchAllContent>

      <Button
        className="w-auto"
        primary
        href={t('pages.404.primary_button.url')}
      >
        {t('pages.404.primary_button.link')}
      </Button>
    </ErrorPage>
  );
};

export default NotFound;
